import store from "./index";

export const namespaced = true;

export const state = {
  filters: new Map(),
  sessionItems: new Map(),
  storageItems: new Map(),
};

export const actions = {
  setFilter({ commit }, params) {
    const key = `filter_${params.type}`;
    const value = JSON.stringify(params.filter);
    //console.log(`localStorage update item key : ${key}, value : ${value}`);
    localStorage.setItem(key, value);

    commit("filter", { type: key, filter: params.filter });
  },
  getFilter({ commit }, type) {
    if (type == null) {
      //console.log("invalid filter type : " + type);
      return null;
    }

    const key = `filter_${type}`;
    const filter = state.filters.get(key);
    if (filter != null) {
      return filter;
    } else {
      //console.log(`localStorage get item key : ${key}`);
      const value = localStorage.getItem(key);
      if (value != null) {
        const filters = JSON.parse(value);
        commit("filter", filters);
        return filters;
      }
      return null;
    }
  },
  setSessionItem({ commit }, params) {
    const key = `session_${params.type}`;
    const value = JSON.stringify(params.items);
    //console.log(`sessionStorage update item key : ${key}, value : ${value}`);
    sessionStorage.setItem(key, value);

    commit("session", { type: key, items: params.items });
  },
  getSessionItem({ commit }, type) {
    if (type == null) {
      console.log("invalid session type : " + type);
      return null;
    }

    const key = `session_${type}`;
    const items = state.sessionItems.get(key);
    if (items != null) {
      return items;
    } else {
      // console.log(`sessionStorage get item key : ${key}`);
      const value = sessionStorage.getItem(key);
      if (value != null) {
        const items = JSON.parse(value);
        commit("session", items);
        return items;
      } else {
        const items = {};
        actions.setSessionItem(
          { commit: commit },
          { type: type, items: items },
        );
        commit("session", items);
        return items;
      }
    }
  },

  setStorageItem({ commit }, params) {
    const key = `storage_${params.type}`;
    const value = JSON.stringify(params.items);
    //console.log(`storage update item key : ${key}, value : ${value}`);
    localStorage.setItem(key, value);

    commit("storage", { type: key, items: params.items });
  },
  getStorageItem({ commit }, type) {
    if (type == null) {
      console.log("invalid storage type : " + type);
      return null;
    }

    const key = `storage_${type}`;
    const items = state.storageItems.get(key);
    if (items != null) {
      // console.log(`storage get item key : ${key}, value : ${items}`);
      return items;
    } else {
      // console.log(`storage get item key : ${key}`);
      const value = localStorage.getItem(key);
      if (value != null) {
        const items = JSON.parse(value);
        commit("storage", items);
        return items;
      } else {
        const items = {};
        actions.setStorageItem(
          { commit: commit },
          { type: type, items: items },
        );
        commit("storage", items);
        return items;
      }
    }
  },
};

export const mutations = {
  filter(state, params) {
    state.filters.set(params.type, params.filter);
  },
  session(state, params) {
    state.sessionItems.set(params.type, params.items);
  },
  storage(state, params) {
    state.storageItems.set(params.type, params.items);
  },
};
